import React from 'react'

import { OrdersList } from 'common/components/OrdersList'
import { PsqlTableCells } from 'common/components/PsqlTable'
import { PsqlColumn } from 'common/components/PsqlTable/psql_table_provider'
import OrderState from 'common/components/statuses/order_state'

import { OrderMaterialCells } from 'contractor/pages/@v2/OrderMaterials/components/cells'
import { ConsolidatedOrdersMaterials } from 'contractor/server/order_materials/consolidated_order_materials'

import { VendorOrderMaterialsCells } from 'vendor/pages/Private/@v2/OrderMaterials/components/cells'
import { Cell } from 'vendor/pages/Private/@v2/Orders/components/cell'

interface Props {
  statusColumn: {
    getNotificationsCount: (id: string) => number
  }
}

export function columnsFactory(props: Props): Array<PsqlColumn<ConsolidatedOrdersMaterials.OrderMaterial>> {
  const { statusColumn } = props

  const baseColumns: Array<PsqlColumn<ConsolidatedOrdersMaterials.OrderMaterial>> = [
    {
      Header: 'Status',
      accessor: 'order_state',
      width: 176,
      Cell: ({ row: { original: item } }) => (
        <OrderState
          state={item.order_state}
          sub_state={item.order_sub_state}
          deliveryIssues={[item.delivery_issue_type]}
          notificationCount={statusColumn.getNotificationsCount(item.order_id)}
          showIssue={item.delivery_has_open_issue}
        />
      ),
    },
    {
      Header: 'Description',
      accessor: 'company_material_description',
      id: 'description',
      ellipsis: true,
      width: 300,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Order',
      accessor: 'order_number',
      width: 400,
      Cell: ({
        row: {
          original: { order_id, order_name, order_number, order_state, order_sub_state, order_package_id },
        },
      }) => {
        return (
          <Cell.OrderNumber
            orderName={order_name}
            orderNumber={order_number}
            orderId={order_id}
            orderPackageId={order_package_id}
            state={order_state}
            subState={order_sub_state}
            basePath="/vendor"
          />
        )
      },
    },
    {
      Header: 'Customer',
      width: 200,
      Cell: ({ row: { original: item }, column }) => (
        <PsqlTableCells.FormattedText
          column={column}
          //{/*@todo: add company_name to consolidated_order_materials*/}
          value={item.company_name}
        />
      ),
    },
    {
      Header: 'Project',
      width: 200,
      Cell: ({ row: { original: item }, column }) => (
        <PsqlTableCells.FormattedText
          column={column}
          value={`${item.project_identifier ? `${item.project_identifier}: ` : ''}${item.project_name}`}
        />
      ),
    },
    {
      Header: 'Qty',
      accessor: 'quantity',
      id: 'quantity',
      width: 120,
      Cell: VendorOrderMaterialsCells.Quantity,
    },
    {
      Header: 'Unit',
      accessor: 'company_material_unit_name',
      id: 'unit',
      width: 120,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Unit Cost',
      accessor: 'unit_cost',
      id: 'unit_cost',
      width: 100,
      format: 'currency',
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Created At',
      accessor: 'created_at',
      id: 'created_at',
      width: 200,
      format: 'date',
      Cell: PsqlTableCells.FormattedText,
    },

    {
      Header: 'Ordered By',
      id: 'order_ordered_by',
      width: 250,
      Cell: ({
        row: {
          original: { order_state, order_ordered_by, order_is_quick_created },
        },
      }) => (
        <OrdersList.Cell.OrderedBy
          state={order_state}
          orderedBy={order_ordered_by}
          quickCreated={order_is_quick_created}
        />
      ),
    },
    {
      Header: 'Ordered At',
      accessor: 'order_ordered_at',
      id: 'order_ordered_at',
      width: 200,
      format: 'date',
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Manufacturer',
      accessor: 'company_material_manufacturer',
      id: 'company_material_manufacturer',
      width: 200,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Size',
      accessor: 'company_material_size',
      id: 'company_material_size',
      width: 200,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Product Identifier',
      accessor: 'company_material_product_identifier',
      id: 'company_material_product_identifier',
      width: 200,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Connection type',
      accessor: 'company_material_connection_type',
      id: 'company_material_connection_type',
      width: 200,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Material',
      accessor: 'company_material_material',
      id: 'company_material_material',
      width: 200,
      Cell: PsqlTableCells.FormattedText,
    },
    {
      Header: 'Vendor note',
      accessor: 'vendor_note',
      id: 'vendor_note',
      width: 200,
      Cell: ({ row: { original: item } }) => (
        <OrderMaterialCells.VendorNote vendorNote={item.vendor_note} vendorResponse={item.vendor_response} />
      ),
    },
  ]

  return baseColumns
}
